import React, { FC } from 'react';
import { Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ManageLinkedDentists from './manage-linked-dentists.component';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

type ManageLinkedDentistsDialogProps = {
    orderId?: string;
    onClose: () => void;
    open: boolean;
};

const ManageLinkedDentistsDialog: FC<ManageLinkedDentistsDialogProps> = ({
    orderId,
    onClose,
    open,
}: ManageLinkedDentistsDialogProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    return (
        <DHDialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            title={translate('orders:MANAGE_PARTICIPANTS')}
            actions={
                <Button onClick={onClose} data-test="manage-linked-dentists-dialog.close-btn">
                    {translate('CLOSE')}
                </Button>
            }
            data-test="manage-linked-dentists-dialog.dialog"
        >
            <Box mt={1}>{orderId ? <ManageLinkedDentists orderId={orderId} /> : undefined}</Box>
        </DHDialog>
    );
};

export default ManageLinkedDentistsDialog;
